import type { FaireProductEntity } from "../../entity_types/product";

export const p_vyewykrd4m: FaireProductEntity = {
  token: "p_vyewykrd4m",
  type: "product",
  name: "Muscle Ease Lotion with Magnesium for Sore Muscles",
  brandToken: "b_129dsr49u5",
  brandName: "Taylor Made Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/8f14e672ac9680e4d92c36816d09fdcb6532bf8bb1df26007650e32d664affe4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53f69e486067dbd28cd7485101e45848519ed7d6c5d196956141909ef6cc95b8.png",
    "https://cdn.faire.com/fastly/20d259a3ea2396aa9aa090db184b9fc3c3b4442f88320869c9fb82579639f23c.png",
  ],
  priceDollars: 6.5,
  description:
    "Therapeutic muscle relief lotion with arnica CO₂, magnesium, and essential oils. Eases soreness from workouts, fibromyalgia, or carpal tunnel pain.\n\nSoothe tired, sore, or overworked muscles with our Muscle Ease Lotion with Magnesium—a restorative formula designed to deliver fast-acting relief and hydration. This therapeutic lotion combines magnesium, arnica CO₂ extract, and a cooling blend of essential oils to calm inflammation, ease tension, and promote recovery.\n\nWhether you’re recovering from an intense workout, managing fibromyalgia, or experiencing carpal tunnel discomfort, this lotion provides targeted comfort with clean, skin-loving ingredients.\n\nKey Ingredients & Benefits:\nMagnesium Chloride – Helps relax muscles and relieve tension.\nArnica CO₂ Extract – Reduces soreness, inflammation, and stiffness.\nPeppermint & Eucalyptus Oils – Deliver cooling relief for fatigued muscles.\nRosemary, Black Pepper & Clove Oils – Support healthy circulation.\nShea Butter & Avocado Oil – Nourish and hydrate without greasiness.\n\n✔ Therapeutic-grade essential oils\n✔ Non-greasy, fast-absorbing lotion\n✔ Ideal for athletes, massage therapists, and wellness enthusiasts\n✔ Organic ingredients | Cruelty-free | Made in the USA\n✔ Free of parabens, glycols, phthalates & synthetic fragrances\n\nExperience natural, magnesium-powered relief that soothes your muscles and softens your skin—all in one clean, effective formula.",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:38.245Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
